import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.invitations
)

export const selectEmployeesInvitations = createSelector(
    baseSelector,
    (state) => state.employeesInvitations
)
export const selectEmployeesInvitationsLoading = createSelector(
    baseSelector,
    (state) => state.isEmployeesInvitationsLoading
)
export const selectEmployeesInvitationsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isEmployeesInvitationsFirstLoad
)
export const selectEmployeesInvitationsError = createSelector(
    baseSelector,
    (state) => state.employeesInvitationsError
)

export const selectUsersInvitations = createSelector(
    baseSelector,
    (state) => state.usersInvitations
)
export const selectUsersInvitationsLoading = createSelector(
    baseSelector,
    (state) => state.isUsersInvitationsLoading
)
export const selectUsersInvitationsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isUsersInvitationsFirstLoad
)
export const selectUsersInvitationsError = createSelector(
    baseSelector,
    (state) => state.usersInvitationsError
)
export const selectInvitations = createSelector(
    baseSelector,
    (state) => state.invitations
)
export const selectInvitationsFirstLoad = createSelector(
    baseSelector,
    (state) => state.invitationsFirstLoad
)